import { render } from "./RoomSubscribe.vue?vue&type=template&id=47a5d1cc&scoped=true"
import script from "./RoomSubscribe.vue?vue&type=script&lang=js"
export * from "./RoomSubscribe.vue?vue&type=script&lang=js"

import "./RoomSubscribe.vue?vue&type=style&index=0&id=47a5d1cc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a5d1cc"]])

export default __exports__